import api from './api';

export const fetchBillsMetrics = async () => {
  const response = await api.get('/bills/metrics');
  return response.data;
}

export const fetchBills = async ({ queryKey }) => {
  const [, { page, limit, search, orderBy, fetch, searchBy, searchByExactMatch }] = queryKey;
  let url = `/bills?page=${page}&limit=${limit}`;
  
  if (search) {
    url += `&search=${search}`;
  }
  if (orderBy) {
    url += `&orderBy=${orderBy}`;
  }
  if (fetch) {
    url += `&fetch=${fetch}`;
  }
  if (searchBy && Array.isArray(searchBy)) {
    const params = searchBy.map((field) => `searchBy=${field}`).join('&');
    url += `&${params}`;
  }
  if (searchByExactMatch) {
    url += `&searchByExactMatch=${searchByExactMatch}`;
  }

  const response = await api.get(url);
  return response.data;
};

export const fetchBill = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/bills/${id}`);
  return response.data;
};

export const exportBill = async (data) => {
  const response = await api.post(`/export/bill`, data);
  return response.data;
}

export const deleteBill = async (id) => {
  const response = await api.delete(`/bills/${id}`);
  return response.data;
}

export const fetchArchivedBills = async ({ queryKey }) => {
  const [, { page, limit, search, fetch }] = queryKey;
  let url = `/bill/archives?page=${page}&limit=${limit}`;

  if (search) {
    url += `&search=${search}`;
  }

  if (fetch) {
    url += `&fetch=${fetch}`;
  }

  const response = await api.get(url);
  return response.data;
}

export const fetchArchivedBill = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  const response = await api.get(`/archived/bills/${id}`);
  return response.data;
}